import * as React from "react";
import PropTypes from "prop-types";
import { Tabs, Tab, Box, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import Statistics from "./Pages/Statistics";
import News from "./Pages/News";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      sx={{ width: "100%" }}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function ModLayout() {
  const [value, setValue] = React.useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container
      sx={{
        display: "flex",
        maxWidth: "lg",
        flexDirection: isMobile ? "column" : "row",
        minHeight: 224,
        mt: 12,
        justifyContent: "space-between",
      }}>
      <Tabs
        orientation={isMobile ? "horizontal" : "vertical"}
        variant="scrollable"
        value={value}
        onChange={handleChange}
        scrollButtons="auto"
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: "divider", overflow: "visible" }}>
        <Tab label="Статистика" {...a11yProps(0)} />
        <Tab label="Новости" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Statistics />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <News />
      </TabPanel>
    </Container>
  );
}
